<template>
    <div class="slideshow-container">
      <div
        class="slides"
        :style="{
          transform: `translateX(-${currentIndex * 100}%)`,
          display: 'flex',
        }"
      >
        <div
          class="slide"
          v-for="(image, index) in images"
          :key="index"
          :style="{ width: '100%' }"
        >
          <img :src="image" alt="Segelfliegen Bilder" class="slide-image" />
        </div>
      </div>
  
      <button @click="prev" class="nav-button prev">❮</button>
      <button @click="next" class="nav-button next">❯</button>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        currentIndex: 0,
        images: [
          '/img/slideshow/H1_1500_600.jpg',
          '/img/slideshow/H2_1500_600.jpg',
          '/img/slideshow/H3_1500_600.jpg',
          '/img/slideshow/H4_1500_600.jpg',
          '/img/slideshow/H5_1500_600.jpg',
        ],
      };
    },
    methods: {
      next() {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
      },
      prev() {
        this.currentIndex =
          (this.currentIndex - 1 + this.images.length) % this.images.length;
      },
    },
    mounted() {
      this.intervalId = setInterval(this.next, 5000);
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
  };
  </script>
  
  
  <style scoped>
  .slideshow-container {
    position: relative;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    overflow: hidden; /* Verhindert das Anzeigen von nicht-aktiven Bildern */
    border-radius: 10px;
  }
  
  .slide {
    display: flex;
    transition: transform 0.5s ease; /* Sanfter Übergang */
    width: 100%;
    flex-shrink: 0;
  }
  
  .slide-image {
    width: 100%; /* Bild füllt den Container */
    height: auto;
    display: block;
  }
  
  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 2rem;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    cursor: pointer;
    z-index: 10;
    user-select: none;
  }
  
  .nav-button.prev {
    left: 10px;
  }
  
  .nav-button.next {
    right: 10px;
  }
  
  .nav-button:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
  </style>
  
  